import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'take' })
export class TakePipe implements PipeTransform {
    transform<T>(values: T[], amount: number, startAt = 0): T[] {
        return values.slice(startAt, startAt + amount);
    }
}
